import React, { useEffect } from 'react';
import { Box, Button, Link } from 'rebass';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from '@apollo/client';

import useCart from 'hooks/usecart';
import { getOrder, createOrder } from 'hooks/graphql';
import { ORDER_TYPE_DOWNLOAD } from 'components/cartprovider';

export default function CheckoutDownload({ studio }) {
  const [cart, dispatch] = useCart();
  const { t } = useTranslation();
  const [addOrder] = useMutation(createOrder);
  const { data, startPolling, stopPolling } = useQuery(getOrder, {
    variables: { id: cart.orderId },
    skip: !cart.orderId,
  });

  // Create the order on component mount
  useEffect(() => {
    (async () => {
      const { data } = await addOrder({
        variables: {
          input: {
            studioId: studio.id,
            type: ORDER_TYPE_DOWNLOAD,
            selection: cart.selection,
          },
        },
      });
      dispatch({
        type: 'set_order_id',
        id: data.createOrder.id,
      });
    })();
  }, []);

  // Stop polling once order has been processed
  useEffect(() => {
    if (data?.getOrder?.status !== 'DONE') {
      startPolling(3000);
    } else {
      stopPolling();
    }
  }, [data]);

  const cancel = () => {
    stopPolling();
    dispatch({ type: 'cancel_order' });
  };

  const close = () => {
    dispatch({ type: 'cancel_order' });
    dispatch({ type: 'empty' });
  };

  return (
    <>
      {data?.getOrder?.status !== 'DONE' && (
        <>
          <Box>{t('checkoutbar.processing')}</Box>
          <Box>
            <Button onClick={cancel} sx={{ marginTop: 2 }}>
              {t('common.cancel')}
            </Button>
          </Box>
        </>
      )}
      {data?.getOrder?.status === 'DONE' && (
        <>
          <Box>{t('checkoutbar.done')}</Box>
          <Box>
            <Link
              variant="button"
              href={data.getOrder.result}
              sx={{ marginTop: 2 }}
            >
              {t('checkoutbar.download')}
            </Link>
          </Box>
          <Box sx={{ marginTop: 3 }}>
            <Button variant="link" onClick={close} sx={{ marginTop: 2 }}>
              {t('common.close')}
            </Button>
          </Box>
        </>
      )}
    </>
  );
}
